export default theme => ({
  root: {
    overflow: 'auto'
  },
  button: {
    marginLeft: theme.spacing(1)
  },
  tourStopTable: {
    margin: theme.spacing(1),
    overflow: 'auto'
  },
  wrapper: {
    display: 'flex',
    margin: theme.spacing(2)
  },
  wrapperChild: {
    flex: 1,
  },
  detail: {
    margin: theme.spacing(1)
  },
  warnButton: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.warning.main,
    '&:hover': {
      backgroundColor: theme.palette.warning.dark,
      color: theme.palette.common.white,
    }
  },
  errorButton: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.danger.main,
    '&:hover': {
      backgroundColor: theme.palette.danger.dark,
      color: theme.palette.common.white,
    }
  },
  buttonContainer: {
    display: 'flex'
  },
  infoIcon: {
    width: 20, height: 16,
    padding: 0,
    margin: 0,
    color: theme.palette.secondary.main
  }
});
